import { render } from "./BookingDisclaimer.vue?vue&type=template&id=cab30038&scoped=true"
import script from "./BookingDisclaimer.vue?vue&type=script&lang=js"
export * from "./BookingDisclaimer.vue?vue&type=script&lang=js"

import "./BookingDisclaimer.vue?vue&type=style&index=0&id=cab30038&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cab30038"]])

export default __exports__